'use client'
import styled from '@emotion/styled'
import React from 'react'
import { SignInForm } from '@common/features/sign-in/SignInForm'

export default function ClientPage() {
  return (
    <>
      <CenteredSignInForm
        onSuccessUrl={
          process.env.NODE_ENV === 'production' ? 'https://admin.booet.se/' : 'http://admin.localhost.test:5173'
        }
        allowDynamicWebsiteRedirect={true}
      />
    </>
  )
}

const CenteredSignInForm = styled(SignInForm)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 80vh;
`
